interface IUpgrade {
  plan: 'all' | 'delivery' | 'table' | 'package' | ' '
  type?: 'new' | 'upgrade' | 'fix' | ' '
  name?: string
  items: string[]
}

export interface IUpdate {
  id: number
  description: string
  upgrades: IUpgrade[]
  createdAt: string
}

export const updates: IUpdate[] = [
  {
    id: 1,
    description: 'Implementação de novas funcionalidades',
    upgrades: [
      {
        plan: ' ',
        type: 'upgrade',
        name: 'Desconto Progressivo ',
        items: [
          `
          <div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:240px; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Sabe aquele recurso incrível nos grandes portais como o Mercado Livre e Amazon onde você entrou para comprar um único produto no entanto acabou comprando mais itens pois no carrinho tinha um oferta irresistível de frete grátis ao completar um certo valor? Agora na WhatsMenu está disponível para sua loja este recurso capaz de dobra o Ticket médio do seu restaurante alem de vender mais para você.</p>
            </div>
          </div>
          `,
        ],
      },
    ],
    createdAt: '2026-03-16T03:00:00.000Z',
  },
  {
    id: 2,
    description: 'Correção de Bugs',
    upgrades: [
      {
        plan: ' ',
        type: 'fix',
        name: 'QrCode da nota fiscal impresso no pedido ',
        items: [
          `
          <div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:240px; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Para você lojista que emite suas notas automaticamente na WhatsMenu agora no pedido já sai impresso o QrCode de acesso direto.</p>
            </div>
          </div>
          `,
        ],
      },
    ],
    createdAt: '2026-03-30T03:00:00.000Z',
  },
  {
    id: 3,
    description: 'Implementação de novas funcionalidades',
    upgrades: [
      {
        plan: ' ',
        type: ' ',
        name: 'Stripe ',
        items: [
          `
          <div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:240px; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Para nossos lojistas Internacionais a maior plataforma de pagamentos globais está pronta integrada para processar suas vendas on-line com segurança, e para os que vendem no Brasil existe o beneficio da GooglePay e ApplePay com o pagar com um clique.</p>
            </div>
          </div>
          `,
        ],
      },
    ],
    createdAt: '2026-04-13T03:00:00.000Z',
  },
  {
    id: 4,
    description: 'Implementação de novas funcionalidades',
    upgrades: [
      {
        plan: ' ',
        name: 'Produtos em Destaque ',
        type: ' ',
        items: [
          `
          <div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:240px; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Como você faz para vender o combo ou produto que te dá mais lucro ou aquele estoque que precisa ver eliminado antes do vencimento, agora você tem uma área de destaque no topo do seu cardápio digital que estimula a venda destes produtos e você seleciona o que destacar para vender mais com apenas um clique.</p>
            </div>
          </div>
          `,
        ],
      },
      {
        plan: ' ',
        name: 'Repasse de taxas dos pagamentos on-line ',
        type: ' ',
        items: [
          `
          <div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:240px; display:flex; flex-direction:column; gap:16px; font-size:1.2rem; font-size:1.2rem;">
            <p>Para você que oferece múltiplas formas de pagamento on-line na sua loja, agora é possível configurar taxa adicional para cobrir os custos de PIX automatizado e pagamentos cartão.</p>
            </div>
          </div>
          `,
        ],
      },
      {
        plan: ' ',
        name: 'Estorno de Pedido Cancelados em Pagamentos Online (Asaas) ',
        type: ' ',
        items: [
          `
          <div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:240px; display:flex; flex-direction:column; gap:16px; font-size:1.2rem; font-size:1.2rem;">
            <p>Caso seja necessário um cancelamento de pedido que já esteja pago é possível ativar a função de estorno automático, desde que você utilize a integração Asaas para pagamentos on-line.</p>
            </div>
          </div>
          `,
        ],
      },
    ],
    createdAt: '2026-04-27T03:00:00.000Z',
  },
  {
    id: 5,
    description: 'Implementação de novas funcionalidades',
    upgrades: [
      {
        plan: ' ',
        name: 'Foto em Complementos ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Quando o cliente não consegue visualizar os adicionais, ele compra só o básico. E, muitas vezes, deixa de incluir aquele extra que aumentaria o valor do pedido. <br /><br />Agora, no WhatsMenu, além da foto principal do produto, você também pode adicionar fotos nos complementos e adicionais.</p>
            <p>Isso deixa seu cardápio mais bonito, mais visual e muito mais vendedor. O cliente entende melhor as opções, sente mais desejo e tem mais chances de turbinar o pedido com bordas, adicionais, sabores, bebidas, molhos e outros extras. <br /><br />Mais fotos, mais desejo, mais pedidos completos e maior ticket médio para o seu restaurante. <br /><br /><strong>Acesse seus produtos agora e comece a adicionar fotos nos complementos.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                src="https://www.youtube.com/embed/oUol-zMDUWU?si=lNwdZN31kotq786c&autoplay=1&mute=1&loop=1&playlist=oUol-zMDUWU"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
      {
        plan: ' ',
        name: 'Novo sinalizador: Consumir no Local ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Pedido para consumir no local não pode entrar no mesmo fluxo de entrega ou retirada. Quando a equipe não identifica isso rápido, pode separar embalagem sem necessidade, atrasar o atendimento e gerar custo extra na operação.
            <br/><br />Agora, o WhatsMenu permite sinalizar pedidos para consumir no local, deixando a lista de pedidos mais clara, organizada e fácil de entender.
            <br/><br />Com ícones e legendas visuais, sua equipe identifica rapidamente cada tipo de pedido, prioriza o atendimento correto e evita desperdício com embalagens.
            <br/><br />Mais controle no balcão, mais agilidade no atendimento e mais economia para o seu restaurante.
            <br/><br /><strong>Acompanhe seus pedidos pelo painel e use essa identificação para organizar melhor sua operação.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                id="videoIframe"
                src="https://www.youtube.com/embed/CLTNGGal3FI?si=P-qh_Aiq91qD7DGs&autoplay=1&loop=1&controls=0&playlist=CLTNGGal3FI"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
      {
        plan: ' ',
        name: 'CMV por Produto ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Vender bastante nem sempre significa lucrar mais. Muitas vezes, o restaurante trabalha muito, mas perde margem porque não sabe calcular quanto custa cada produto vendido.
            <br/><br />Agora, no WhatsMenu, você pode cadastrar o custo do produto e ver os indicadores para tomar a melhor decisão do preço de venda.
            <br/><br />Além disso, os relatórios de CMV ajudam você a enxergar quais produtos são mais lucrativos, quais precisam de reajuste e onde sua operação pode estar perdendo dinheiro.
            <br/><br />Mais controle financeiro, decisões de preço mais inteligentes e uma gestão muito mais profissional para o seu restaurante.
            <br/><br /><strong>Acesse seus produtos agora, informe os custos e acompanhe seu CMV pelo painel.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                id="videoIframe"
                src="https://www.youtube.com/embed/Hx-2KT5QHRQ?si=J71ecck48HmFPkfZ&autoplay=1&loop=1&controls=0&playlist=Hx-2KT5QHRQ"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
      {
        plan: ' ',
        name: 'Código nos Produtos ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Na hora do atendimento, cada segundo conta. Procurar produto pelo nome no PDV pode atrasar a venda, confundir a equipe e aumentar o risco de lançar o item errado no pedido do cliente.
            <br/><br />Agora, no WhatsMenu, você pode cadastrar códigos personalizados para encontrar e lançar itens com muito mais rapidez no PDV.
            <br/><br />Basta digitar o código do produto e confirmar, deixando o atendimento mais ágil, prático e seguro.
            <br/><br />Mais velocidade no balcão, menos erro nos pedidos e uma operação muito mais profissional para sua equipe.
            <br/><br /><strong>Acesse seus produtos agora, cadastre os códigos e agilize seus lançamentos no PDV.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                id="videoIframe"
                src="https://www.youtube.com/embed/YkNjSt02rSg?si=kvXjFEIQfbLoj7ir&autoplay=1&loop=1&controls=0&playlist=YkNjSt02rSg"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
      {
        plan: ' ',
        name: 'Impressão automática por ambiente ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Pedido perdido, cozinha confusa e equipe perguntando o tempo todo "esse pedido é de onde?" atrasa a operação e prejudica a experiência do cliente.
            <br/><br />Agora, com a impressão automática por ambiente, cada setor recebe exatamente o que precisa produzir, sem bagunça e sem retrabalho.
            <br/><br />Mais organização para sua equipe, mais velocidade na produção e mais controle para o seu restaurante.
            <br/><br /><strong>Acesse agora suas configurações de impressão e aproveite esse recurso no seu dia a dia.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                id="videoIframe"
                src="https://www.youtube.com/embed/cAXLeH9F-9E?si=DBj4Jwu1CCvp4Qpu&autoplay=1&loop=1&controls=0&playlist=cAXLeH9F-9E"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
    ],
    createdAt: '2026-05-09T03:00:00.000Z',
  },
  {
    id: 6,
    description: 'Implementando novos recursos',
    upgrades: [
      {
        plan: ' ',
        name: 'Fechamento de Corridas e Diárias dos Entregadores ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Controlar pagamento de motoboy no caderninho dá trabalho, toma tempo e pode gerar dúvidas na hora de fechar as corridas, diárias e valores a receber.
            <br/><br />Você configura o valor fixo das diárias, o sistema registra cada corrida concluída e calcula o total que cada entregador tem a receber no período escolhido.
            <br/><br />Depois, é só filtrar por dia, semana ou mês, imprimir o extrato detalhado e manter tudo documentado com clareza e transparência entre o restaurante e o entregador.
            <br/><br />Mais controle, menos erro, menos cálculo manual e muito mais profissionalismo na gestão das suas entregas.
            <br/><br /><strong>Acesse o relatório de entregadores, filtre o período desejado e faça seus fechamentos com muito mais segurança.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                id="videoIframe"
                src="https://www.youtube.com/embed/7zTORc_j7hY?si=ZCslh5k-mYrqmfEN&autoplay=1&loop=1&controls=0&playlist=7zTORc_j7hY"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
    ],
    createdAt: '2026-05-16T03:00:00.000Z',
  },
  {
    id: 7,
    description: 'Implementando novos recursos',
    upgrades: [
      {
        plan: ' ',
        name: 'Promoções Relâmpago ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Tem produto que precisa girar mais rápido, horário que precisa vender melhor e oferta que só funciona quando o cliente sente que precisa aproveitar agora.
            <br /><br />Com as Promoções Relâmpago do WhatsMenu, você pode destacar ofertas no seu cardápio com contador de tempo para acabar, criando urgência e estimulando o cliente a comprar no momento certo.
            <br /><br />Você também pode programar a data de início e encerramento da promoção, deixando tudo automático, sem precisar ativar ou remover manualmente.
            <br /><br />Ideal para almoço promocional, happy hour, fim de semana, datas especiais ou para vender produtos mais estratégicos e lucrativos.
            <br /><br />Mais vendas em horários importantes, mais controle sobre suas campanhas e um cardápio muito mais vendedor para o seu restaurante.
            <br /><br /><strong>Acesse suas promoções agora e programe sua próxima Promoção Relâmpago.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                id="videoIframe"
                src="https://www.youtube.com/embed/D44ON4qUM5o?si=6g0k1r5J7X8x2j3A&autoplay=1&mute=1&loop=1&controls=0&playlist=D44ON4qUM5o"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
      {
        plan: ' ',
        name: 'Ícones nas Categorias do Cardápio ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
          <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
            <p>Um cardápio confuso ou pouco visual pode fazer o cliente demorar mais para encontrar o que deseja — e quanto mais difícil a navegação, maior a chance dele desistir da compra.
            <br /><br />Agora, no WhatsMenu, você pode adicionar ícones personalizados nas categorias do seu cardápio.
            <br /><br />Com isso, cada seção fica mais fácil de identificar, a navegação se torna mais intuitiva e o cardápio ganha uma aparência mais moderna, organizada e profissional.
            <br /><br />Além de valorizar a identidade visual da sua marca, os ícones ajudam o cliente a encontrar rapidamente o que procura, melhorando a experiência de compra e aumentando as chances de conversão.
            <br /><br />Pequenos detalhes fazem grande diferença: um cardápio mais bonito, mais claro e mais vendedor para o seu restaurante.
            <br /><br /><strong>Acesse suas categorias agora e personalize os ícones do seu cardápio.</strong></p>
          </div>
          <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                id="videoIframe"
                src="https://www.youtube.com/embed/gb9lRESFC9U?si=Z0wC5y5UQz10Zg-f&autoplay=1&mute=1&loop=1&controls=0&playlist=gb9lRESFC9U"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style="position:absolute; top:0; left:0; width:100%; height:100%; border-radius:8px;">
              </iframe>
            </div>
          </div>
        </div>`,
        ],
      },
      {
        plan: ' ',
        name: 'Flags nos Produtos ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
              <p>Nem sempre o cliente percebe os produtos mais estratégicos do seu cardápio. E quando tudo aparece igual, lançamentos, campeões de venda e ofertas especiais podem passar despercebidos.
              <br /><br />Agora, no WhatsMenu, você pode adicionar flags nos produtos, criando marcadores visuais para destacar os itens que merecem mais atenção.
              <br /><br />Use para sinalizar lançamentos, mais vendidos, promoções, novidades ou produtos com maior potencial de venda, sem deixar o cardápio poluído.
              <br /><br />Com esse recurso, seu cardápio fica mais moderno, organizado e vendedor, ajudando o cliente a encontrar rapidamente o que vale a pena comprar.
              <br /><br />Mais destaque para os produtos certos, mais estratégia na navegação e mais chances de aumentar suas vendas.
              <br /><br /><strong>Acesse seus produtos agora e use as flags para destacar os itens mais importantes do seu cardápio.</strong></p>
            </div>
            <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                  id="videoIframe"
                  src="https://www.youtube.com/embed/NZBGAIhnU9k?si=FX7RFZ36VRMt6TTg&autoplay=1&mute=1&loop=1&controls=0&playlist=NZBGAIhnU9k"
                  title="YouTube video player"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowfullscreen
                  loading="lazy"
                  style="position:absolute; top:0; left:0; width:100%; height:100%; border:0; border-radius:8px;">
              </iframe>
          </div>
          </div>
        </div>`,
        ],
      },
    ],
    createdAt: '2026-06-30T03:00:00.000Z',
  },
  {
    id: 8,
    description: 'Implementando novos recursos',
    upgrades: [
      {
        plan: ' ',
        name: 'Fiado',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
              <p>Anotar fiado no papel ou confiar apenas na memória pode gerar confusão, cobrança esquecida e falta de controle sobre os valores em aberto.
              <br /><br />Agora, no WhatsMenu, você pode criar contas individuais para seus clientes comprarem ao longo do tempo e pagarem depois, de forma muito mais prática e organizada.
              <br /><br />Com o Fiado, você acompanha os valores pendentes, mantém tudo registrado e oferece mais flexibilidade para clientes de confiança.
              <br /><br />Mais controle financeiro, mais segurança nas cobranças e uma experiência de compra que ajuda a fortalecer o relacionamento com seus clientes.
              <br /><br /><strong>Acesse Mesas no PDV e comece a organizar suas contas em aberto direto pelo WhatsMenu.</strong></p>
            </div>
            <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                  id="videoIframe"
                  src="https://www.youtube.com/embed/riaPztdUVKM?si=coZxa8ssaaKSnug5&autoplay=1&mute=1&loop=1&controls=0&playlist=riaPztdUVKM"
                  title="YouTube video player"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowfullscreen
                  loading="lazy"
                  style="position:absolute; top:0; left:0; width:100%; height:100%; border:0; border-radius:8px;">
              </iframe>
          </div>
          </div>`,
        ],
      },
      {
        plan: ' ',
        name: 'Integração de Relatórios com os Portais ',
        type: ' ',
        items: [
          `<div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
              <p>Quando os pedidos vêm de vários canais, fica mais difícil entender quais plataformas realmente estão movimentando as vendas do restaurante.
              <br /><br />Agora, o relatório de pedidos diários e mensais do WhatsMenu ficou ainda mais completo: além de acompanhar todas as informações dos pedidos, você identifica facilmente de onde cada venda veio, com ícones da <strong>Keeta, 99Food e iFood</strong>.
              <br /><br />A novidade também inclui o gráfico de <strong><u><i>Plataformas Mais Pedidas</i></u></strong>, mostrando quais aplicativos mais geram pedidos para o seu estabelecimento.
              <br /><br />Mais clareza nos dados, mais praticidade na gestão e decisões muito mais estratégicas para sua operação.
              <br /><br /><strong>Acesse seus relatórios e acompanhe o desempenho de cada plataforma direto pelo WhatsMenu.</strong></p>
            </div>
            <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                  id="videoIframe"
                  src="https://www.youtube.com/embed/4d3LGVkLG30?si=kLiwckqxa9t5XX2m&autoplay=1&mute=1&loop=1&controls=0&playlist=4d3LGVkLG30"
                  title="YouTube video player"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowfullscreen
                  loading="lazy"
                  style="position:absolute; top:0; left:0; width:100%; height:100%; border:0; border-radius:8px;">
              </iframe>
          </div>
          </div>`,
        ],
      },
    ],
    createdAt: '2026-08-04T03:00:00.000Z',
  },
  {
    id: 9,
    description: 'Implementação de novas funcionalidades',
    upgrades: [
      {
        plan: ' ',
        type: 'new',
        name: 'Novo Dashboard Estratégico ',
        items: [
          `
          <div style="display:flex; flex-wrap:wrap; gap:20px; align-items:flex-start;">
            <div style="flex:1 1 320px; min-width:0; display:flex; flex-direction:column; gap:16px; font-size:1.2rem;">
              <p>Quando você não vê seus números com clareza, o restaurante pode estar perdendo dinheiro sem você perceber.
              <br /><br />Agora, o WhatsMenu reúne os principais indicadores da sua operação em uma única tela: faturamento, pedidos, formas de pagamento, novos clientes, clientes recorrentes, cupons e muito mais.
              <br /><br />Com gráficos claros e insights automáticos, você identifica rapidamente quedas nas vendas, horários de maior movimento, canais que mais vendem e oportunidades para melhorar seus resultados.
              <br /><br />Mais controle, mais agilidade e decisões baseadas em dados, não em achismo.
              <br /><br /><strong>Acesse sua Dashboard Estratégica e acompanhe sua operação em uma única tela.</strong></p>
            </div>
            <div style="flex:0 1 560px; width:100%; max-width:560px; min-width:0;">
            <div style="position:relative; width:100%; padding-top:56.25%;">
              <iframe
                  id="videoIframe"
                  src="https://www.youtube.com/embed/POikG-2HRQA?si=irODtKIonEO2GVd2&autoplay=1&mute=1&loop=1&controls=0&playlist=POikG-2HRQA"
                  title="YouTube video player"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowfullscreen
                  loading="lazy"
                  style="position:absolute; top:0; left:0; width:100%; height:100%; border:0; border-radius:8px;">
              </iframe>
          </div>
          </div>
          `,
        ],
      },
    ],
    createdAt: '2026-10-01T03:00:00.000Z',
  },
]
